import React from 'react';
import styled from '@emotion/styled';
import moment from 'moment-timezone';
import { FORMAT_DATETIME_US } from '../../../constants/common';

interface DatetimeColumnProps {
  date: string | any;
  isHighlight?: boolean;
  format?: string;
  className?: string;
  minWidth?: string | number;
}

export default React.memo((props: DatetimeColumnProps) => {
  const { date, isHighlight, format, className, minWidth } = props;
  if (!date) {
    return (
      <StyledContainer style={{ minWidth }} className={className || ''}>
        <span>TBD</span>
      </StyledContainer>
    );
  }
  if (isHighlight) {
    const outDated = moment(date).isBefore(moment());
    return (
      <StyledContainer style={{ minWidth }} className={className || ''}>
        <span className={outDated ? 'active' : ''}>{moment(date).format(format || FORMAT_DATETIME_US)}</span>
      </StyledContainer>
    );
  }
  return (
    <StyledContainer style={{ minWidth }} className={className || ''}>
      <span>{moment(date).format(format || FORMAT_DATETIME_US)}</span>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  // display: flex;
  align-items: center;
  span {
    font-weight: 600;
    &.active {
      color: #d61010;
    }
  }
`;
